import { useTranslation } from 'react-i18next';

import { PlainTextBlock } from '../../../line-message-form';
import { LineMessageBlock } from '../shared';

export const LineMessagePreviewPlainText = ({ text }: PlainTextBlock) => {
  const { t } = useTranslation('crm');

  return (
    <LineMessageBlock.Container title={t('crm.lineMessagePreview.plainText.title')}>
      <li className="crm-line-message-preview__list-item grid-cols-1" key={`plain-text-${text}`}>
        <p className="line-clamp-1">{text}</p>
      </li>
    </LineMessageBlock.Container>
  );
};
